// ═══════════════════════════════════════════════════════════
// GabChart — Chart.js wrapper for analytics pages
// ═══════════════════════════════════════════════════════════

import { Bar, Doughnut, Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement,
  PointElement, LineElement, Title, Tooltip, Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, PointElement, LineElement, Title, Tooltip, Legend);

interface ChartData {
  labels: string[];
  values: number[];
  colors?: string[];
}

const DEFAULT_COLORS = ['#4B3FFF', '#059669', '#d97706', '#dc2626', '#0284c7', '#7c3aed', '#6b7280', '#f97316'];

export function GabBarChart({ data, height = 250 }: { data: ChartData; height?: number }) {
  return (
    <div style={{ height }}>
      <Bar
        data={{
          labels: data.labels,
          datasets: [{ data: data.values, backgroundColor: data.colors || DEFAULT_COLORS.slice(0, data.values.length), borderRadius: 4 }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true } } }}
      />
    </div>
  );
}

export function GabDonutChart({ data, height = 250 }: { data: ChartData; height?: number }) {
  return (
    <div style={{ height }}>
      <Doughnut
        data={{
          labels: data.labels,
          datasets: [{ data: data.values, backgroundColor: data.colors || DEFAULT_COLORS.slice(0, data.values.length) }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { position: 'right' } } }}
      />
    </div>
  );
}

export function GabLineChart({ data, height = 250, label = '' }: { data: ChartData; height?: number; label?: string }) {
  return (
    <div style={{ height }}>
      <Line
        data={{
          labels: data.labels,
          datasets: [{ label, data: data.values, borderColor: '#4B3FFF', backgroundColor: 'rgba(75, 63, 255, 0.1)', fill: true, tension: 0.3 }],
        }}
        options={{ responsive: true, maintainAspectRatio: false, plugins: { legend: { display: !!label } }, scales: { y: { beginAtZero: true } } }}
      />
    </div>
  );
}
